import React, { PropTypes } from 'react';
import AcceptModal from 'components/leads/acceptModal';
import RejectLead from 'components/rejectLead';

class AcceptBar extends React.Component {
    constructor(props) {
        super(props);

        this.handleBuyClosed = this.handleBuyClosed.bind(this);
        this.handleTooFewCredits = this.handleTooFewCredits.bind(this);

        this.state = {
            tooFewCredits: false,
            showAccept: false,
        };
    }

    handleBuyClosed() {
        this.setState({ showBuy: false, showAccept: true, tooFewCredits: false });
    }

    handleTooFewCredits() {
        this.setState({ showBuy: true, showAccept: false, tooFewCredits: true });
    }

    render() {
        return (
            <div className="event-notice">
                <div className="container">
                    <span className="notice-message">
                        Would you like to respond to this lead?
                    </span>

                    <span className="notice-actions">
                        <AcceptModal
                            lead={this.props.lead}
                            onClickBuy={this.handleBuyClick}
                            onTooFewCredits={this.handleTooFewCredits}
                            open={this.state.showAccept}
                        />

                        <RejectLead leadId={this.props.lead.id} />
                    </span>
                </div>
            </div>
        );
    }
}

AcceptBar.propTypes = {
    lead: PropTypes.object.isRequired,
};

export default AcceptBar;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/leads/acceptBar.jsx